import { Col, Row } from "antd";
import ClipboardCopy from "../../components/clipboard";

const GetStarted = ({ BrandToken }) => {
  return (
    <Row className="getstarted">
      <Col span={12}>
        <h6>Embed Web Widget (Classic)</h6>
        <p>
          Copy the following script and insert it into your website's HTML
          source code between the head tags or the footer tags.
          <br />
          This code must be inserted into root page it will display the widget on all pages.
        </p>

        <h1>Copy to Clipboard</h1>
        <ClipboardCopy BrandToken={BrandToken} />
      </Col>
    </Row>
  );
};
export default GetStarted;  